import React from 'react';

const UNewTag = (props) => {
    return (
        <React.Fragment>
            <p className={`${props?.withoutPosition ? 'u_new-tag-side-menu' : 'u_new-tag'} ${props?.color || ''} ${props?.className || ''}`} style={props?.style}>
                <span className="u_new-tag-inner">
                    {props.title || 'New'}
                </span>
            </p>
        </React.Fragment>
    );
};

export default UNewTag;